/* * @Author: knight * @Title: 即将上线 * @Date: 2020-04-07 17:57:47 * @Last
Modified by: knight * @Last Modified time: 2020-05-21 11:15:53 */
<template>
  <div
    :class="['coming-soon-wrapper', { 'no-slide': disableSlide }]"
    ref="comingSoonWrapper"
  >
    <div class="block-title">即将上线</div>
    <list-slider
      slide-type="click"
      :length="list.length"
      :hasSlider="realList.length > showItemNumber"
      @clickpre="delIndex"
      @clicknext="addIndex"
    >
      <div class="card-wrapper clearfix">
        <div
          class="card-item"
          v-for="(item, index) in list"
          :key="index + '_' + item[itemKey]"
        >
          <template
            v-if="item.preview_id"
            v-reportShow="{
              module: 'lecture_previews',
              data: {
                ssid: '',
                appointment_id: item.preview_id
              }
            }"
          >
            <div
              :class="[
                'time-line-wrapper',
                {
                  'is-today':
                    item.release_time_format === '今天' ||
                    item.release_time_format === '明天',
                  empty: item.line && item.line.empty,
                },
              ]"
            >
              <div class="time">{{ item.release_time_format }}</div>
              <div class="line">
                <div class="point-wrapper">
                  <span class="point"></span>
                </div>
              </div>
            </div>
            <div class="info-wrapper">
              <div class="cover-wrapper">
                <div
                  :style="{ width: imgWidth + 'px', height: imgHeight + 'px' }"
                >
                  <lazy-img
                    :src="item.cover"
                    :width="imgWidth"
                    :height="imgHeight"
                    cut
                  ></lazy-img>
                </div>

                <slot name="followInfo" :item="item">
                </slot>

                <div class="block-list-item-info-mask"></div>
              </div>

              <div class="title">
                <p class="title_txt">{{ item.title }}</p>
                <div class="tags">
                  <div class="tag ell">{{ item.tags | tagLimit }}</div>
                </div>
              </div>
            </div>
          </template>
        </div>
      </div>

      <template v-slot:slider-control>
        <div class="block-page-progress">{{ currentProgress }}</div>
      </template>
    </list-slider>
  </div>
</template>

<script>
import ListSlider from 'g-public/components/ListSlider'
import LazyImg from 'g-public/components/CommonLazyImg'
import { quickLogin, getStyle, getWindowW } from 'g-public/utils'

export default {
  props: {
    itemKey: {
      type: String,
      default: () => {
        return 'ssId'
      },
    },

    isShowLineTime: {
      type: Boolean,
      default: false,
    },

    imgWidth: {
      type: Number,
      default: 160,
    },

    imgHeight: {
      type: Number,
      default: 214,
    },
    // 上线内容原始数据
    realList: {
      type: Array,
      default: () => [],
    },
    // 请求上线内容方法
    // getList: {
    //     type: Function,
    //     required: true
    // },
    // 获取预约列表数据方法
    // getFollowList: {
    //     type: Function,
    //     required: true
    // },
    // 预约方法
    clickFollow: {
      type: Function,
    },
    // 预约展示类型
    followType: {
      type: String,
      default: 'default',
    },
    // 行数
    wrap: {
      type: Number,
      default: 1,
    },
  },

  data() {
    return {
      outWrapperWidth: 'auto',
      disableSlide: false,
      isLogin: false,
      wideMode: false,
      index: 1,
      showItemNumber: 5,
      resizeHandler: () => {},
    }
  },
  computed: {
    list() {
      const arr = []
      for (const key in this.realList) {
        arr.push(this.realList[key])
      }

      const slideBorder = this.wideMode ? 6 : 5
      this.disableSlide = this.realList.length < slideBorder
      if (this.realList.length > 0 && this.realList.length < slideBorder) {
        const less = slideBorder - this.realList.length
        for (let i = 0; i < less; i++) {
          arr.push({})
        }
      }

      return arr
    },

    maxPage() {
      return Math.ceil(this.realList.length / this.showItemNumber)
    },

    currentProgress() {
      return `${this.index}/${this.maxPage}`
    },
  },
  filters: {
    tagLimit(vals) {
      if (!vals) return ''
      return vals.reduce((acc, cur) => acc + cur + '      ', '')
    },
  },

  mounted() {
    this.resizeHandler = window.funcThrottle(16, false, () => {
      const windowW = getWindowW()
      if (windowW > 1400) {
        this.showItemNumber = 6
        this.wideMode = true
      } else {
        this.showItemNumber = 5
        this.wideMode = true
      }
      this.index = 1
    })
    this.resizeHandler()
    window.addEventListener(
        'resize',
        this.resizeHandler,
      window.supportPassive ? { passive: false } : false,
    )
  },
  beforeDestroy() {
    window.removeEventListener(
        'resize',
        this.resizeHandler,
      window.supportPassive ? { passive: false } : false,
    )
  },
  methods: {
    getCardItemSkew() {
      const $target = document.querySelector('.card-item')
      const marginRight = getStyle($target, 'marginRight')
      const marginLeft = getStyle($target, 'marginLeft')
      // 去掉px
      const cardItemWidth =
        Number(marginRight.replace(/px/, '')) +
        Number(marginLeft.replace(/px/, '')) +
        $target.offsetWidth
      return this.showListItemNumber * cardItemWidth
    },

    _clickFollow(e, item) {
      e.stopPropagation()
      e.preventDefault()
      if (this.isLogin) {
        this.clickFollow()
      } else {
        quickLogin()
      }
    },
    caseBadge(badge) {
      const BADGE_ENUM = [
        '付费',
        '合作',
        '话题',
        '热播',
        '首播',
        '推荐',
        '预告',
        '最新',
      ]
      const index = BADGE_ENUM.indexOf(badge)
      return index > -1 ? `case${index}` : ''
    },
    addIndex() {
      if (this.index + 1 > this.maxPage) return
      this.index++
    },
    delIndex() {
      if (this.index - 1 < 1) return
      this.index--
    },
  },
  components: { ListSlider, LazyImg },
}
</script>

<style lang="less" scoped>
.coming-soon-wrapper {
  &.no-slide {
    .slider-contro {
      display: none;
    }
  }
  .block-title {
    font-size: 18px;
    font-weight: 400;
    line-height: 22px;
    margin-bottom: 20px;
    color: #222;
  }
  .slider-contro {
    position: absolute;
    right: auto;
    top: 0;
    padding-right: 0;
    border-right: none;
    width: 100%;
    transition: all 0.3s ease;
    span {
      position: absolute;
      top: 160px;
      display: block;
      width: 34px;
      height: 34px;
      border-radius: 50%;
      background-repeat: no-repeat;
      background-color: #fff;
      background-image: url(../assets/images/icons.png);
      box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.16);
      transition: all 0.2s linear;
      cursor: pointer;
      z-index: 2;
      &.slider-prev {
        left: -17px;
        background-position: -463px -1679px;
      }
      &.slider-next {
        right: -17px;
        background-position: -461px -1615px;
      }
      &:hover {
        box-shadow: 0 0 8px rgba(0, 0, 0, 0.24);
      }
      &.disabled {
        opacity: 0;
      }
    }
  }
  .card-wrapper {
    // height: 330px;
    white-space: nowrap;
    transition: all 0.3s ease;
    .card-item {
      position: relative;
      // width: 160px;
      // margin-right: 10px;
      padding-right: 10px;
      display: inline-block;
      vertical-align: top;
      // height: 330px;
      &:last-child {
        padding-right: 0;
      }
    }
  }
}

.time-line-wrapper {
  height: 70px;
  text-align: center;
  padding-left: 10px;
  &.empty {
    .date {
      color: #99a2aa;
      // transform: translateY(11px);
    }
  }
  &.is-today {
    // .date, .time {
    //     color: #f25d8e;
    // }
    .line .point {
      background-color: #f25d8e;
    }
  }
  .date {
    height: 18px;
    line-height: 18px;
    font-size: 14px;
    color: #222;
    margin-bottom: 6px;
  }
  .time {
    height: 15px;
    line-height: 15px;
    font-size: 12px;
    color: #222;
    margin-bottom: 14px;
  }
  .line {
    position: absolute;
    left: 0;
    right: 0;
    top: 53px;
    height: 1px;
    background-color: #e5e9ef;
    .point-wrapper {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 17px;
      height: 5px;
      background-color: #fff;
    }

    .point {
      display: block;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 5px;
      height: 5px;
      border-radius: 50%;
      background-color: #ccd0d7;
    }
  }
}

.info-wrapper {
  width: 100%;
  // &:hover .title {
  //     color: #00a1d6;
  // }
  .cover-wrapper {
    position: relative;
    display: block;
    width: 100%;
    // height: 214px;
    border-radius: 4px;
    overflow: hidden;
    .btn-follow {
      position: absolute;
      top: 0;
      left: 0;
      width: 30px;
      height: 30px;
      border-radius: 4px 0 4px 0;
      background-color: rgba(0, 0, 0, 0.5);
      background-repeat: no-repeat;
      background-image: url(../assets/images/btn-follow.png);
      background-size: 18px;
      background-position: 6px 8px;
      &.followed {
        background-position: 6px -32px;
      }
    }
    .badge {
      position: absolute;
      width: 38px;
      height: 33px;
      background: url(../assets/images/btag.png) no-repeat;
      top: 0;
      right: 6px;
      &.case0 {
        background-position: 0 0;
      }
      &.case1 {
        background-position: 0 -40px;
      }
      &.case2 {
        background-position: 0 -80px;
      }
      &.case3 {
        background-position: 0 -120px;
      }
      &.case4 {
        background-position: 0 -160px;
      }
      &.case5 {
        background-position: 0 -200px;
      }
      &.case6 {
        background-position: 0 -240px;
      }
      &.case7 {
        background-position: 0 -280px;
      }
    }
  }
  .title,
  .desc {
    display: block;
    margin-top: 10px;
    height: 15px;
    line-height: 15px;
    font-size: 12px;
    color: #222;
    // white-space: nowrap;
    // overflow: hidden;
    // text-overflow: ellipsis;
    // transition: color .3s ease;
  }
  .desc {
    margin-top: 6px;
    color: #99a2aa;
  }
}

.block-page-progress {
  width: 25px;
  color: #212121;
  line-height: 16px;
  margin: 0 26px;
  user-select: none;
}

.tags {
  font-size: 12px;
  color: #999999;
  overflow: hidden;
  // margin-top: 8px;
  position: absolute;
  bottom: 0;
  left: 0;
  background: #fff;
  z-index: 10;
  width: 100%;
  height: 24px;
  line-height: 30px;
}

.tag {
  display: inline-block;
  vertical-align: middle;
  margin-right: 10px;
  max-width: 100%;
}

.block-list-item-info-mask {
  position: absolute;
  width: 100%;
  height: 58px;
  bottom: 0;
  left: 0;
  background-image: linear-gradient(
    180deg,
    rgba(0, 0, 0, 0) 0%,
    rgba(0, 0, 0, 0.6) 100%
  );
  border-radius: 0 0 2px 2px;
  z-index: 1;
}

.title:hover {
  .tags {
    animation: tags-move 0.3s forwards;
  }
}

.title_txt {
  word-break: break-all;
  white-space: initial;
  word-wrap: break-word;
  height: 44px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  white-space: normal;
  word-break: break-all;
}

@keyframes tags-move {
  0% {
    bottom: 0;
  }

  100% {
    bottom: -20px;
  }
}
</style>
